import * as z from "zod/v4";
import { RepairFee, RepairInvoiceDetails } from "./get-repair-invoice-details";

export const updateRepairInvoice = {
  name: "updateRepairInvoice" as const,
  input: z.object({ returnId: z.string(), fees: z.array(RepairFee) }),
  output: RepairInvoiceDetails,
};
